import React from "react";
import { createUseStyles, useTheme } from "react-jss";

import styles from "./styles";

interface Props {
  children: React.ReactNode;
}

const Accordion = (props: Props) => {
  const { children } = props;
  const useStyles = createUseStyles(styles);
  const theme = useTheme();
  const classes = useStyles({
    theme,
    ...props,
  });

  return <div className={classes.accordion}>{children}</div>;
};

export default Accordion;
try {
    // @ts-ignore
    Accordion.displayName = "Accordion";
    // @ts-ignore
    Accordion.__docgenInfo = { "description": "", "displayName": "Accordion", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/Accordion/Accordion.tsx#Accordion"] = { docgenInfo: Accordion.__docgenInfo, name: "Accordion", path: "src/shared/components/Accordion/Accordion.tsx#Accordion" };
}
catch (__react_docgen_typescript_loader_error) { }